import React, { useEffect, useState } from 'react'

import { useHomeContent } from '../../../hooks/useHomeContent'
import useWindowDimensions from '../../../hooks/useWindowDimensions'

const FirstColumnHeader = () => {
  const [width, setWidh] = useState(0)
  const { width: screenWidth } = useWindowDimensions()

  useEffect(() => {
    if (screenWidth) {
      setWidh(screenWidth)
    }
  }, [screenWidth])

  const { logo } = useHomeContent()

  return (
    <div
      className="telesales-navbar__first-column"
      data-testid="first-header-row"
    >
      <div className="site-logotipo">
        <img
          src={width < 768 ? logo?.['image-mobile'] : logo?.image}
          alt={logo?.alt}
        />
      </div>
    </div>
  )
}

export default FirstColumnHeader
